



import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { FaSearch, FaPlus } from 'react-icons/fa';
import axios from 'axios';


import { FaEdit, FaTrash } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


Modal.setAppElement('#root');


const styles = {
  container: { display: 'flex', height: '100vh', fontFamily: 'Arial, sans-serif', },
  sidebar: { width: '250px', backgroundColor: '#2c3e50', color: '#ecf0f1', padding: '20px', },
  menuItem: { padding: '10px 0', cursor: 'pointer', borderBottom: '1px solid #34495e', },
  menuItemHover: { backgroundColor: '#34495e', },
  content: { flex: 1, backgroundColor: '#ecf0f1', padding: '20px', },
  table: { width: '100%', borderCollapse: 'collapse', },
  thtd: { border: '1px solid #ccc', padding: '8px', textAlign: 'left', },
  container1: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif', },
  header: { fontSize: '28px', fontWeight: '600', color: '#4B0082', marginBottom: '30px', textAlign: 'center', },
  form: { width: '100%', maxWidth: '500px', padding: '30px', backgroundColor: '#fff', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', borderRadius: '8px', },
  formGroup: { marginBottom: '20px', },
  label: { fontSize: '16px', fontWeight: '500', color: '#333', marginBottom: '10px', display: 'block', },
  select: { width: '100%', padding: '12px', fontSize: '16px', borderRadius: '8px', border: '1px solid #ddd', backgroundColor: '#f7f7f7', transition: 'border-color 0.3s ease', cursor: 'pointer', },
  input: { width: '100%', padding: '12px', fontSize: '16px', borderRadius: '8px', border: '1px solid #ddd', backgroundColor: '#f7f7f7', transition: 'border-color 0.3s ease', },
  button: { width: '100%', backgroundColor: '#4B0082', color: '#fff', padding: '14px', fontSize: '18px', fontWeight: '600', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.3s ease', marginTop: '20px', },
  buttonHover: { backgroundColor: '#5a1d9e', },
  error: { color: 'red', textAlign: 'center', marginBottom: '20px', },
  pdfList: { display: 'flex', flexDirection: 'row', flexWrap: "wrap", marginTop: '20px', gap: '10px', },
  pdfItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', transition: 'box-shadow 0.3s', margin: '20px', },
  pdfItemHover: { boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)', },
  pdfDetails: { flex: 1, fontSize: '16px', width: '200px' },
  pdfLink: { color: '#4B0082', textDecoration: 'none', fontWeight: '500', margin: '20px', },
  deleteButton: { backgroundColor: '#ff4d4d', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 15px', cursor: 'pointer', fontSize: '14px', transition: 'background-color 0.3s', },
  deleteButtonHover: { backgroundColor: '#ff3333', },
  noData: { textAlign: 'center', color: '#888', fontSize: '16px', },
};


function Admin() {
  const [activeMenu, setActiveMenu] = useState('Dashboard');
  const menuItems = ['Dashboard', 'Users', 'Settings', 'Magazine', 'Profile Approval', 'ImagesUpload', 'HomeBanner', 'ServeIndia'];


  return (
    <div style={styles.container}>
      <div style={styles.sidebar}>
        <h2>Admin Panel</h2>
        {menuItems.map((item, index) => (
          <div
            key={index}
            style={styles.menuItem}
            onClick={() => setActiveMenu(item)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = styles.menuItemHover.backgroundColor)
            }
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
          >
            {item}
          </div>
        ))}
      </div>

      <div style={styles.content}>
        {/* Conditionally render each section here */}
        {activeMenu === 'Dashboard' && <Dashboard />}
        {activeMenu === 'Users' && <Users />}
        {activeMenu === 'Settings' && <Settings />}
        {activeMenu === 'Magazine' && <Magazine />}
        {activeMenu === 'Profile Approval' && <ProfileApproval />}
        {activeMenu === 'ImagesUpload' && <ImagesUpload />}
        {activeMenu === 'HomeBanner' && <HomeBanner />}
        {activeMenu === 'ServeIndia' && <ServeIndia />}

        {/* {activeMenu === 'Logout' && <Logout />} */}
      </div>
    </div>
  );
}


function Dashboard() {
  const [menus, setMenus] = useState([]);
  const [subMenus, setSubMenus] = useState([]);
  const [subPlusMenus, setSubPlusMenus] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null);
  const [formData, setFormData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Fetch data
  const fetchMenus = async () => {
    const menus = await fetch("https://lcoiapi.emedha.in/appi/menus_all").then(r => r.json());
    setMenus(menus);
  };
  const fetchSubMenus = async () => {
    const subs = await fetch("https://lcoiapi.emedha.in/appi/sub_menus").then(r => r.json());
    setSubMenus(subs);
  };
  const fetchSubPlus = async () => {
    const subs = await fetch("https://lcoiapi.emedha.in/appi/sub_plus_menus").then(r => r.json());
    setSubPlusMenus(subs);
  };


  useEffect(() => {
    fetchMenus();
    fetchSubMenus();
    fetchSubPlus();

  }, []);



  const mergedData = [];

  menus.forEach((menu) => {
    const relatedSubs = subMenus.filter((sub) => sub.menu_id === menu.id);

    if (relatedSubs.length === 0) {
      mergedData.push({
        menu: menu.menu,
        submenu: "No SubMenu",
        subplusmenu: "No SubPlusMenu"
      });
    } else {
      relatedSubs.forEach((sub) => {
        const relatedPlus = subPlusMenus.filter(
          (sp) => sp.sub_menus_id === sub.id
        );

        if (relatedPlus.length === 0) {
          mergedData.push({
            menu: menu.menu,
            submenu: sub.sub_menu,
            subplusmenu: ""
          });
        } else {
          relatedPlus.forEach((sp) => {
            mergedData.push({
              menu: menu.menu,
              submenu: sub.sub_menu,
              subplusmenu: sp.sub_plus_menus
            });
          });
        }
      });
    }
  });

  console.log(mergedData);


  console.log('this is filtered', filtered)
  // POST handler
  const handleSubmit = async () => {
    let url = '', payload = {};
    if (modal === 'menu') {
      url = "https://lcoiapi.emedha.in/appi/menus";
      payload = { menu: formData.menu };
    }
    if (modal === 'submenu') {
      url = "https://lcoiapi.emedha.in/appi/sub_menus";
      payload = { menu_id: formData.menu_id, sub_menu: formData.sub_menu };
    }
    if (modal === 'subplusmenu') {
      url = "https://lcoiapi.emedha.in/appi/sub_plus_menus";
      payload = { sub_menus_id: formData.sub_menus_id, sub_plus_menus: formData.sub_plus_menus };
    }
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    setModal(null); setFormData({});
    await Promise.all([fetchMenus(), fetchSubMenus(), fetchSubPlus()]);
  };

  // Filter + paginate
  const filteredData = mergedData.filter(item =>
    `${item.menu} ${item.submenu} ${item.subplusmenu}`.toLowerCase().includes(search.toLowerCase())
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const pageData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  // Styles
  const btn = {
    padding: '8px 12px', border: 'none', borderRadius: 4,
    background: '#007bff', color: '#fff', cursor: 'pointer'
  };
  const inputStyle = { width: '100%', padding: 8, marginBottom: 10, border: '1px solid #ccc', borderRadius: 4 };
  const thtd = { border: '1px solid #ddd', padding: 8, textAlign: 'left' };
  const modalStyle = {
    position: 'fixed', top: '10%', left: '50%', transform: 'translateX(-50%)',
    width: 400, background: '#fff', padding: 20,
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1000
  };

  return (
    <div style={{ fontFamily: 'Arial,sans-serif', padding: 20 }}>
      <h2 style={{ marginBottom: 20 }}>Dashboard - Menu Manager</h2>
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        <button style={btn} onClick={() => setModal('menu')}>➕ Create Menu</button>
        <button style={btn} onClick={() => setModal('submenu')}>➕ Create Submenu</button>
        <button style={btn} onClick={() => setModal('subplusmenu')}>➕ Create SubPlusMenu</button>
        <input type="text" placeholder="Search..."
          style={{ padding: 8, flex: 1, border: '1px solid #ccc', borderRadius: 4 }}
          value={search} onChange={e => { setSearch(e.target.value); setCurrentPage(1); }} />
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>
            {['ID', 'Menu', 'Submenu', 'SubPlusMenu'].map(h => (
              <th key={h} style={thtd}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {pageData.map((item, index) => (
              <tr key={item.id}>
                <td style={thtd}>{index + 1}</td>
                <td style={thtd}>{item.menu}</td>
                <td style={thtd}>{item.submenu}</td>
                <td style={thtd}>{item.subplusmenu}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 20, display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 15, flexWrap: 'wrap' }}>
        <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: currentPage === 1 ? '#eee' : '#007BFF', color: currentPage === 1 ? '#aaa' : '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>Prev</button>
        <span style={{ fontWeight: 'bold' }}>Page {currentPage} of {totalPages}</span>
        <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: currentPage === totalPages ? '#eee' : '#007BFF', color: currentPage === totalPages ? '#aaa' : '#fff', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>Next</button>
      </div>


      {modal && (
        <div style={modalStyle}>
          <h3 style={{ marginBottom: 10 }}>Create {modal}</h3>

          {modal === 'menu' && (
            <input type="text" placeholder="Menu name" value={formData.menu || ''}
              onChange={e => setFormData({ ...formData, menu: e.target.value })} style={inputStyle} />
          )}

          {modal === 'submenu' && (
            <>
              <select style={inputStyle} value={formData.menu_id || ''}
                onChange={e => setFormData({ ...formData, menu_id: e.target.value })}>
                <option value="">Select Menu</option>
                {menus.map(m => <option key={m.id} value={m.id}>{m.menu}</option>)}
              </select>
              <input type="text" placeholder="Submenu name" value={formData.sub_menu || ''}
                onChange={e => setFormData({ ...formData, sub_menu: e.target.value })} style={inputStyle} />
            </>
          )}

          {modal === 'subplusmenu' && (
            <>
              <select style={inputStyle} value={formData.menu_id || ''}
                onChange={e => {
                  const menu_id = e.target.value;
                  const subs = subMenus.filter(s => s.menu_id == menu_id);
                  setFormData({ menu_id, sub_menus_id: '', filteredSubs: subs });
                }}>
                <option value="">Select Menu</option>
                {menus.map(m => <option key={m.id} value={m.id}>{m.menu}</option>)}
              </select>
              <select style={inputStyle} value={formData.sub_menus_id || ''}
                onChange={e => setFormData({ ...formData, sub_menus_id: e.target.value })}>
                <option value="">Select Submenu</option>
                {(formData.filteredSubs || []).map(s =>
                  <option key={s.id} value={s.id}>{s.sub_menu}</option>
                )}
              </select>
              <input type="text" placeholder="SubPlusMenu name" value={formData.sub_plus_menus || ''}
                onChange={e => setFormData({ ...formData, sub_plus_menus: e.target.value })} style={inputStyle} />
            </>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 10 }}>
            <button style={btn} onClick={handleSubmit}>Submit</button>
            <button style={{ ...btn, background: '#aaa' }} onClick={() => setModal(null)}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}






const Magazine = () => {
  const [month, setMonth] = useState('');
  const [pdf, setPdf] = useState(null);
  const [pdfList, setPdfList] = useState([]);
  const [language, setLanguage] = useState('English');
  const [error, setError] = useState('');

  // Fetch the list of PDFs when the component mounts
  useEffect(() => {
    fetchPdfList();
  }, []);

  // Fetch PDF list from the backend
  const fetchPdfList = async () => {
    try {
      const response = await axios.get('https://lcoiapi.emedha.in/pdf/api/pdf');
      setPdfList(response.data);
      setError('');
    } catch (error) {
      setError('Error fetching PDF list');
    }
  };

  // Handle deleting a PDF
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://lcoiapi.emedha.in/pdf/api/pdf/${id}`);
      fetchPdfList(); // Refresh the list after deletion
    } catch (error) {
      setError('Error deleting PDF');
    }
  };


  const handleMonthChange = (e) => setMonth(e.target.value);
  const handleFileChange = (e) => setPdf(e.target.files[0]);
  const handleLanguageChange = (e) => setLanguage(e.target.value);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('month', month);
    formData.append('pdf', pdf);
    formData.append('language', language);

    try {
      const response = await axios.post('https://lcoiapi.emedha.in/pdf/api/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Success alert
      alert('Upload Successful: PDF uploaded successfully.');
      console.log('Upload Success:', response.data);

    } catch (error) {
      // Error alert
      alert('Error uploading file: ' + (error.response?.data?.message || 'Please try again.'));
      console.error('Error uploading file:', error);
    }
  };

  return (
    <div style={styles.container1}>
      <h2 style={styles.header}>Upload Magazine PDF</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Select Month:</label>
          <select value={month} onChange={handleMonthChange} style={styles.select}>
            <option value="">Select Month</option>
            {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Upload PDF:</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            style={styles.input}
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Select Language:</label>
          <select value={language} onChange={handleLanguageChange} style={styles.select}>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
          </select>
        </div>

        <button type="submit" style={styles.button}>Submit</button>
      </form>
      <div style={styles.pdfList}>
        {pdfList.length > 0 ? (
          pdfList.map((pdf) => (
            <div key={pdf.id} style={styles.pdfItem}>
              <div style={styles.pdfDetails}>
                <a href={pdf.pdf_url} target="_blank" rel="noopener noreferrer" style={styles.pdfLink}>
                  {pdf.month} Magazine
                </a>
                <p style={{ color: 'red', marginLeft: '20px' }}>{pdf.language}</p>
              </div>

              <button onClick={() => handleDelete(pdf.id)} style={styles.deleteButton}>
                Delete
              </button>
            </div>
          ))
        ) : (
          <div style={styles.noData}>No PDFs uploaded yet</div>
        )}
      </div>
    </div>
  );
};



const ProfileApproval = () => {
  const [pendingProfiles, setPendingProfiles] = useState([]);

  // ✅ Fetch pending profiles from indian_leadership_edit
  useEffect(() => {
    fetchPendingProfiles();
  }, []);

  const fetchPendingProfiles = async () => {
    try {
      const res = await axios.get("https://lcoiapi.emedha.in/api/otp/api/admin/pending-edits");
      setPendingProfiles(res.data); // API should return all rows from indian_leadership_edit where not approved
    } catch (err) {
      console.error("Error fetching pending profiles:", err);
    }
  };

  // ✅ Approve edit → update indian_leadership and mark as approved in edit table
  const handleApprove = async (profile) => {
    try {
      const res = await axios.post("https://lcoiapi.emedha.in/api/otp/api/admin/approve-edit", {
        id: profile.id,
        email: profile.email,
      });

      if (res.data.success) {
        alert("Profile approved & updated!");
        fetchPendingProfiles(); // refresh
      } else {
        alert(res.data.message || "Failed to approve");
      }
    } catch (err) {
      console.error("Error approving profile:", err);
    }
  };

  // ❌ Reject edit → delete or mark rejected in edit table
  const handleReject = async (profile) => {
    try {
      const res = await axios.post("https://lcoiapi.emedha.in/api/otp/api/admin/reject-edit", {
        id: profile.id,
        email: profile.email,
      });

      if (res.data.success) {
        alert("Profile rejected!");
        fetchPendingProfiles();
      } else {
        alert(res.data.message || "Failed to reject");
      }
    } catch (err) {
      console.error("Error rejecting profile:", err);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ fontSize: 22, fontWeight: "bold", marginBottom: 16 }}>Pending Profile Approvals</h2>

      {pendingProfiles.length === 0 ? (
        <p>No pending profiles</p>
      ) : (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 20 }}>
          {pendingProfiles.map((p) => (
            <div key={p.id} style={{ border: "1px solid #ccc", borderRadius: 12, padding: 16, width: 280, background: "#fff", boxShadow: "0 4px 10px rgba(0,0,0,0.1)", }}>
              <img src={p.image} alt={p.name} style={{ width: 90, height: 90, borderRadius: "50%", objectFit: "cover", marginBottom: 12, }} />
              <h3 style={{ margin: "6px 0", fontWeight: "600" }}>{p.name}</h3>
              <p>{p.desegnation}</p>
              <p>📧 {p.email}</p>
              <p>📞 {p.number}</p>
              <p>📍 {p.location}</p>

              <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                <button onClick={() => handleApprove(p)} style={{ flex: 1, padding: "6px 10px", background: "#16a34a", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", }}>Approve</button>
                <button onClick={() => handleReject(p)} style={{ flex: 1, padding: "6px 10px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", }}>Reject</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};









// Separate component for Users (with table)
function Users() {

  const [users, setUsers] = useState([]);

  const fetchUsers = async () => {
    const subs = await fetch("https://lcoiapi.emedha.in/appi/users").then(r => r.json());
    setUsers(subs);
  };
  useEffect(() => {
    fetchUsers();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };


  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  // Calculate paginated data
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate page numbers
  const totalPages = Math.ceil(users.length / usersPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);


  return (
    <>
      <div>
        <h1>User Management</h1>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.thtd}>ID</th>
              <th style={styles.thtd}>Email</th>
              <th style={styles.thtd}>created_at</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.map((user) => (
              <tr key={user.id}>
                <td style={styles.thtd}>{user.id}</td>
                <td style={styles.thtd}>{user.email}</td>
                <td style={styles.thtd}>{formatDate(user.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: '20px', textAlign: 'start' }}>
        <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={{ marginRight: '10px', padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: currentPage === 1 ? '#eee' : '#007BFF', color: currentPage === 1 ? '#aaa' : '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }} >Prev</button>
        <span style={{ fontWeight: 'bold', margin: '0 10px' }}>Page {currentPage} of {totalPages}</span>
        <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={{ marginLeft: '10px', padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: currentPage === totalPages ? '#eee' : '#007BFF', color: currentPage === totalPages ? '#aaa' : '#fff', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>Next</button>
      </div>
    </>
  );
}


// Settings component
function Settings() {
  const [menus, setMenus] = useState([]);
  const [subMenus, setSubMenus] = useState([]);
  const [subPlusMenus, setSubPlusMenus] = useState([]);
  const [menusData, setMenusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const [searchTerm, setSearchTerm] = useState("");


  console.log('this is menus_id', menus)
  console.log('this is sub_menus_id', subMenus)
  console.log('this is sub_plus_menus_id', subPlusMenus)

  const getMenuName = (id) => {
    const found = menus.find((m) => m.id === Number(id));
    return found ? found.menu : "No Menu";
  };

  const getSubMenuName = (id) => {
    const found = subMenus.find((s) => s.id === Number(id));
    return found ? found.sub_menu : "No Submenu";
  };

  const getSubPlusMenuName = (id) => {
    const found = subPlusMenus.find((s) => s.id === Number(id));
    return found ? found.sub_plus_menus : "No Subplusmenu";
  };


  // Filtered Data
  const filteredMenus = menusData.filter((item) => {
    const menuName = getMenuName(item.menus_id).toLowerCase();
    const subMenu = getSubMenuName(item.sub_menus_id).toLowerCase();
    const subPlusMenu =
      item.sub_plus_menus_id === "\\N" || !item.sub_plus_menus_id
        ? "no subplusmenu"
        : getSubPlusMenuName(item.sub_plus_menus_id).toLowerCase();
    const heading = item.heading?.toLowerCase() || "";
    const content = item.content?.toLowerCase() || "";

    return (
      menuName.includes(searchTerm.toLowerCase()) ||
      subMenu.includes(searchTerm.toLowerCase()) ||
      subPlusMenu.includes(searchTerm.toLowerCase()) ||
      heading.includes(searchTerm.toLowerCase()) ||
      content.includes(searchTerm.toLowerCase())
    );
  });

  const fetchDataMenu = async () => {
    try {
      const response = await fetch("https://lcoiapi.emedha.in/appi/menus_all");
      const data = await response.json();
      setMenus(data);
    } catch (error) {
      console.error("Error fetching menus:", error);
    }
  };
  const fetchDataSubMenu = async () => {
    try {
      const response = await fetch("https://lcoiapi.emedha.in/appi/sub_menus");
      const data = await response.json();
      setSubMenus(data);
    } catch (error) {
      console.error("Error fetching menus:", error);
    }
  };
  const fetchDataSubPlusMenu = async () => {
    try {
      const response = await fetch("https://lcoiapi.emedha.in/appi/sub_plus_menus");
      const data = await response.json();
      setSubPlusMenus(data);
    } catch (error) {
      console.error("Error fetching menus:", error);
    }
  };


  const fetchData = async () => {
    try {
      const response = await fetch("https://lcoiapi.emedha.in/appi/menus_data_all");
      const data = await response.json();
      setMenusData(data);
    } catch (error) {
      console.error("Error fetching menus:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDataMenu();
    fetchDataSubMenu();
    fetchDataSubPlusMenu();
  }, []);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMenus = filteredMenus.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredMenus.length / itemsPerPage);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    menus_id: '',
    sub_menus_id: '',
    sub_plus_menus_id: '',
    image: '',
    heading: '',
    content: ''
  });

  const inputStyle = { width: '100%', padding: '10px', margin: '8px 0', borderRadius: '6px', border: '1px solid #ccc', fontSize: '14px' };

  const handleSubmit1 = async () => {
    try {
      let imageUrl = '';
      if (formData.image && typeof formData.image === 'object') {
        const form = new FormData();
        form.append('image', formData.image);

        const uploadRes = await fetch('https://lcoiapi.emedha.in/appi/menus_post', {
          method: 'POST',
          body: form,
        });

        const uploadData = await uploadRes.json();
        imageUrl = uploadData.imageUrl;
      }

      const payload = {
        ...formData,
        image: imageUrl || formData.image, // fallback to text URL if present
      };

      const res = await fetch('https://lcoiapi.emedha.in/appi/menus_post', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        alert('Menu item added!');
        setModalIsOpen(false);
        setFormData({
          menus_id: '',
          sub_menus_id: '',
          sub_plus_menus_id: '',
          image: '',
          heading: '',
          content: '',
        });
        fetchData();
      } else {
        alert('Failed to submit form.');
      }
    } catch (err) {
      console.error(err);
      alert('Error submitting form.');
    }
  };

  const handleSubmit = async () => {
    try {
      const form = new FormData();

      form.append('menus_id', formData.menus_id);
      form.append('sub_menus_id', formData.sub_menus_id);
      form.append('sub_plus_menus_id', formData.sub_plus_menus_id || '');
      form.append('heading', formData.heading);
      form.append('content', formData.content);

      if (formData.image && typeof formData.image === 'object') {
        form.append('image', formData.image);
      }

      const res = await fetch('https://lcoiapi.emedha.in/appi/menus_post', {
        method: 'POST',
        body: form, // DO NOT set headers — let browser handle it
      });

      if (res.ok) {
        alert('Menu item added!');
        setModalIsOpen(false);
        setFormData({
          menus_id: '',
          sub_menus_id: '',
          sub_plus_menus_id: '',
          image: '',
          heading: '',
          content: '',
        });
        fetchData();
      } else {
        alert('Failed to submit form.');
      }
    } catch (err) {
      console.error('Submit error:', err);
      alert('Error submitting form.');
    }
  };


  return (
    <div>
      <h1>Menu Data Create</h1>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' }}>
        <div style={{ position: 'relative', flex: 1, minWidth: '250px' }}>
          <FaSearch style={{ position: 'absolute', top: '50%', left: '10px', transform: 'translateY(-50%)', color: '#888' }} />
          <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ width: '100%', padding: '10px 10px 10px 35px', border: '1px solid #ccc', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
        </div>
        <button onClick={() => setModalIsOpen(true)} style={{ display: 'flex', alignItems: 'center', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 15px', cursor: 'pointer', fontSize: '14px' }}>
          <FaPlus style={{ marginRight: '6px' }} /> Add Menu Data
        </button>
      </div>


      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.thtd}>ID</th>
            <th style={styles.thtd}>image</th>
            <th style={styles.thtd}>menus_id</th>
            <th style={styles.thtd}>sub_menus_id</th>
            <th style={styles.thtd}>sub_plus_menus_id</th>
            <th style={styles.thtd}>Heading</th>
            <th style={styles.thtd}>Content</th>
          </tr>
        </thead>
        <tbody>
          {currentMenus.map((menu) => (
            <tr key={menu.id}>
              <td style={styles.thtd}>{menu.id}</td>
              <td style={styles.thtd}><img src={menu.image} alt="menu" style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "4px" }} /></td>
              <td style={styles.thtd}>{getMenuName(menu.menus_id)}</td>
              <td style={styles.thtd}>{getSubMenuName(menu.sub_menus_id)}</td>
              <td style={styles.thtd}>
                {menu.sub_plus_menus_id === "\\N" || !menu.sub_plus_menus_id
                  ? "No Subplusmenu"
                  : getSubPlusMenuName(menu.sub_plus_menus_id)}
              </td>
              <td style={styles.thtd}>{menu.heading}</td>
              <td style={styles.thtd}>{menu.content}</td>
            </tr>
          ))}
        </tbody>

      </table>
      <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)} contentLabel="Add Menu Data" style={{ content: { maxWidth: '500px', margin: 'auto', padding: '20px', borderRadius: '10px', } }}>
        <h2>Add Menu Data</h2>
        <select value={formData.menus_id} onChange={(e) => setFormData({ ...formData, menus_id: e.target.value, sub_menus_id: '', sub_plus_menus_id: '' })} style={inputStyle}>
          <option value="">Select Menu</option>
          {menus.map((m) => (
            <option key={m.id} value={m.id}>{m.menu}</option>
          ))}
        </select>
        <select value={formData.sub_menus_id} onChange={(e) => setFormData({ ...formData, sub_menus_id: e.target.value, sub_plus_menus_id: '' })} style={inputStyle}>
          <option value="">Select Sub Menu</option>
          {subMenus
            .filter((s) => s.menu_id == formData.menus_id)
            .map((s) => (
              <option key={s.id} value={s.id}>{s.sub_menu}</option>
            ))}
        </select>

        <select value={formData.sub_plus_menus_id} onChange={(e) => setFormData({ ...formData, sub_plus_menus_id: e.target.value })} style={inputStyle} >
          <option value="">Select Sub Plus Menu</option>
          {subPlusMenus
            .filter((sp) => sp.sub_menus_id == formData.sub_menus_id)
            .map((sp) => (
              <option key={sp.id} value={sp.id}>{sp.sub_plus_menus}</option>
            ))}
        </select>

        <input type="file" accept="image/*" onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })} style={inputStyle} />
        <input type="text" placeholder="Heading" value={formData.heading} onChange={(e) => setFormData({ ...formData, heading: e.target.value })} style={inputStyle} />
        <textarea placeholder="Content" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} style={{ ...inputStyle, height: '80px' }} />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button onClick={() => setModalIsOpen(false)}>Cancel</button>
          <button onClick={handleSubmit} style={{ backgroundColor: '#007bff', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '5px' }}>Submit</button>
        </div>
      </Modal>

      <div style={{ marginTop: "20px", display: "flex", justifyContent: "start", alignItems: "center", gap: "15px", flexWrap: "wrap" }}>
        <button onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1} style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: currentPage === 1 ? '#eee' : '#007BFF', color: currentPage === 1 ? '#aaa' : '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>Prev</button>
        <span style={{ fontWeight: 'bold' }}>Page {currentPage} of {totalPages}</span>
        <button onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #ccc', backgroundColor: currentPage === totalPages ? '#eee' : '#007BFF', color: currentPage === totalPages ? '#aaa' : '#fff', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>Next</button>
      </div>

    </div>
  );
}

const APII = "https://lcoiapi.emedha.in/appi";





// Logout component
function ImagesUpload() {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ title: "", image: null });
  const [editId, setEditId] = useState(null);

  const fetchData = async () => {
    const res = await axios.get(`${APII}/images`);
    setData(res.data);
  };

  useEffect(() => {
    fetchData();

  }, []);



  const handleSubmit = async () => {
    try {
      const fd = new FormData();
      fd.append("title", form.title);
      if (form.image) fd.append("image", form.image);

      if (editId) {
        await axios.put(`${APII}/images/${editId}`, fd);
        toast.success("Updated!");
        setData((prev) => [
          {
            id: Date.now(), // temp id
            title: form.title,
            image_url: form.image
              ? URL.createObjectURL(form.image)
              : null,
          },
          ...prev,
        ]);
      } else {
        await axios.post(`${APII}/images`, fd);
        toast.success("Created!");
      }

      // ✅ IMPORTANT: wait before closing
      await fetchData();

      setModal(false);
      setForm({ title: "", image: null });
      setEditId(null);

    } catch {
      toast.error("Error occurred");
    }
  };
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this item?")) return;

    await axios.delete(`${APII}/images/${id}`);
    toast.success("Deleted!");
    fetchData();
  };

  const openEdit = (item) => {
    setForm({ title: item.title, image: null });
    setEditId(item.id);
    setModal(true);
  };


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(data.length / itemsPerPage);



  return (
    <>
      <div style={{ padding: 20, fontFamily: "Arial" }}>
        <ToastContainer />
        <h2 style={{ marginBottom: 20 }}>Image Manager</h2>
        <button onClick={() => setModal(true)} style={{ background: "#4CAF50", color: "#fff", padding: "10px 15px", border: "none", borderRadius: 5, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, marginBottom: 20, }}><FaPlus /> Add Image</button>
        <table style={{ width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", }}>
          <thead style={{ background: "#f5f5f5" }}>
            <tr>
              <th style={{ padding: 12, textAlign: "left", }}>#</th>
              <th style={{ padding: 12, textAlign: "left", }}>Title</th>
              <th style={{ padding: 12, textAlign: "left", }}>Image</th>
              <th style={{ padding: 12, textAlign: "left", }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {currentData.map((item, index) => (
              <tr key={item.id}>
                <td style={{ padding: 12, borderBottom: "1px solid #ddd", }}>{indexOfFirstItem + index + 1}</td>
                <td style={{ padding: 12, borderBottom: "1px solid #ddd", }}>{item.title}</td>
                <td style={{ padding: 12, borderBottom: "1px solid #ddd", }}><img src={item.image_url} alt="" style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 5, }} /></td>
                <td style={{ padding: 12, borderBottom: "1px solid #ddd", }}><FaEdit onClick={() => openEdit(item)} style={{ color: "#2196F3", cursor: "pointer", marginRight: 10, }} /><FaTrash onClick={() => handleDelete(item.id)} style={{ color: "#f44336", cursor: "pointer" }} /></td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Modal */}
        {modal && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", }}>
            <div style={{ background: "#fff", padding: 20, borderRadius: 8, width: 320, boxShadow: "0 5px 15px rgba(0,0,0,0.3)", }}>
              <h3 style={{ marginBottom: 15 }}>{editId ? "Edit Image" : "Add Image"}</h3>
              <input type="text" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} style={{ width: "100%", padding: 8, marginBottom: 10, borderRadius: 5, border: "1px solid #ccc", }} />
              <input type="file" onChange={(e) => setForm({ ...form, image: e.target.files[0] })} style={{ marginBottom: 15 }} />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button style={{ background: "#4CAF50", color: "#fff", border: "none", padding: "8px 12px", borderRadius: 5, cursor: "pointer", }} onClick={handleSubmit}>Submit</button>
                <button style={{ background: "#ccc", border: "none", padding: "8px 12px", borderRadius: 5, cursor: "pointer", }} onClick={() => setModal(false)}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div style={{ marginTop: 20, textAlign: "center" }}>
        <button onClick={() => setCurrentPage((p) => p - 1)} disabled={currentPage === 1} style={{ marginRight: 10, padding: "5px 10px", cursor: "pointer", }}>Prev</button>
        <span>Page {currentPage} of {totalPages}</span>
        <button onClick={() => setCurrentPage((p) => p + 1)} disabled={currentPage === totalPages} style={{ marginLeft: 10, padding: "5px 10px", cursor: "pointer", }}>Next</button>
      </div>
    </>
  );
}








const APIIBB = "https://lcoiapi.emedha.in/appi";

function HomeBanner() {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    title: "",
    description: "",
    button_name: "",
    button_url: "",
    image: null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Track window width for inline responsive behavior
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;

  // =========================
  // Fetch Data
  // =========================
  const fetchData = async () => {
    try {
      const res = await axios.get(`${APIIBB}/home-banners`);
      setData(res.data);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch banners");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // =========================
  // Reset Form
  // =========================
  const resetForm = () => {
    setForm({
      title: "",
      description: "",
      button_name: "",
      button_url: "",
      image: null,
    });

    setEditId(null);
  };

  // =========================
  // Open Add Modal
  // =========================
  const openAdd = () => {
    resetForm();
    setModal(true);
  };

  // =========================
  // Open Edit Modal
  // =========================
  const openEdit = (item) => {
    setForm({
      title: item.title || "",
      description: item.description || "",
      button_name: item.button_name || "",
      button_url: item.button_url || "",
      image: null,
    });

    setEditId(item.id);
    setModal(true);
  };

  // =========================
  // Close Modal
  // =========================
  const closeModal = () => {
    setModal(false);
    resetForm();
  };

  // =========================
  // Handle Input
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // =========================
  // Handle Image
  // =========================
  const handleImageChange = (e) => {
    setForm((prev) => ({
      ...prev,
      image: e.target.files?.[0] || null,
    }));
  };

  // =========================
  // Create / Update
  // =========================
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!form.title.trim()) {
        toast.error("Please enter title");
        return;
      }

      if (!form.description.trim()) {
        toast.error("Please enter description");
        return;
      }

      if (!editId && !form.image) {
        toast.error("Please select an image");
        return;
      }

      const fd = new FormData();

      fd.append("title", form.title);
      fd.append("description", form.description);
      fd.append("button_name", form.button_name);
      fd.append("button_url", form.button_url);

      if (form.image) {
        fd.append("image", form.image);
      }

      if (editId) {
        await axios.put(`${APIIBB}/home-banners/${editId}`, fd);
        toast.success("Banner updated successfully!");
      } else {
        await axios.post(`${APIIBB}/home-banners`, fd);
        toast.success("Banner created successfully!");
      }

      await fetchData();
      closeModal();
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    }
  };

  // =========================
  // Delete
  // =========================
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) {
      return;
    }

    try {
      await axios.delete(`${APIIBB}/home-banners/${id}`);
      toast.success("Banner deleted successfully!");
      await fetchData();
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete banner");
    }
  };

  // =========================
  // Pagination
  // =========================
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.max(1, Math.ceil(data.length / itemsPerPage));

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  // =========================
  // JSX
  // =========================
  return (
    <>
      <ToastContainer />

      <div style={{ padding: isMobile ? 12 : 20, fontFamily: "Arial, sans-serif", maxWidth: "1200px", margin: "0 auto", boxSizing: "border-box", }}>
        {/* Header */}
        <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: isMobile ? "stretch" : "center", gap: isMobile ? 12 : 0, marginBottom: 20, }}>
          <h2 style={{ margin: 0, fontSize: isMobile ? "20px" : "24px" }}>Home Banner Manager</h2>

          <button onClick={openAdd} style={{ background: "#4CAF50", color: "#fff", border: "none", padding: "10px 16px", borderRadius: 5, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, fontSize: "14px", fontWeight: "bold", width: isMobile ? "100%" : "auto", }}>
            <FaPlus />
            Add Banner
          </button>
        </div>

        {/* Content Layout: Table for Desktop, Cards for Mobile */}
        {isMobile ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
            {currentData.length > 0 ? (
              currentData.map((item, index) => (
                <div
                  key={item.id}
                  style={{
                    background: "#fff",
                    borderRadius: 8,
                    padding: 15,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontWeight: "bold", color: "#666" }}>
                      #{indexOfFirstItem + index + 1}
                    </span>
                    <div style={{ display: "flex", gap: 15 }}>
                      <FaEdit
                        onClick={() => openEdit(item)}
                        style={{
                          color: "#2196F3",
                          cursor: "pointer",
                          fontSize: "18px",
                        }}
                      />
                      <FaTrash
                        onClick={() => handleDelete(item.id)}
                        style={{
                          color: "#f44336",
                          cursor: "pointer",
                          fontSize: "18px",
                        }}
                      />
                    </div>
                  </div>

                  {item.image_url && (
                    <img
                      src={item.image_url}
                      alt={item.title || "Banner"}
                      style={{
                        width: "100%",
                        height: 160,
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                    />
                  )}

                  <div>
                    <strong style={{ fontSize: "16px" }}>{item.title}</strong>
                    <p
                      style={{
                        margin: "5px 0 0 0",
                        color: "#555",
                        fontSize: "14px",
                        wordBreak: "break-word",
                      }}
                    >
                      {item.description}
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderTop: "1px solid #eee",
                      paddingTop: 8,
                      fontSize: "13px",
                    }}
                  >
                    <span>
                      <strong>Button:</strong> {item.button_name || "-"}
                    </span>
                    {item.button_url ? (
                      <a
                        href={item.button_url}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "#2196F3", textDecoration: "none" }}
                      >
                        Open Link
                      </a>
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  background: "#fff",
                  padding: 30,
                  textAlign: "center",
                  color: "#777",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                No banners found
              </div>
            )}
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                background: "#fff",
                borderRadius: 8,
                overflow: "hidden",
              }}
            >
              <thead style={{ background: "#f5f5f5" }}>
                <tr>
                  <th style={thStyle}>#</th>
                  <th style={thStyle}>Image</th>
                  <th style={thStyle}>Title</th>
                  <th style={thStyle}>Description</th>
                  <th style={thStyle}>Button</th>
                  <th style={thStyle}>URL</th>
                  <th style={thStyle}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((item, index) => (
                    <tr key={item.id}>
                      <td style={tdStyle}>
                        {indexOfFirstItem + index + 1}
                      </td>
                      <td style={tdStyle}>
                        <img
                          src={item.image_url}
                          alt={item.title || "Banner"}
                          style={{
                            width: 100,
                            height: 60,
                            objectFit: "cover",
                            borderRadius: 5,
                          }}
                        />
                      </td>
                      <td style={tdStyle}>{item.title}</td>
                      <td style={{ ...tdStyle, maxWidth: 250 }}>
                        {item.description}
                      </td>
                      <td style={tdStyle}>{item.button_name || "-"}</td>
                      <td style={tdStyle}>
                        {item.button_url ? (
                          <a
                            href={item.button_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Open
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td style={tdStyle}>
                        <FaEdit
                          onClick={() => openEdit(item)}
                          style={{
                            color: "#2196F3",
                            cursor: "pointer",
                            marginRight: 15,
                          }}
                        />
                        <FaTrash
                          onClick={() => handleDelete(item.id)}
                          style={{
                            color: "#f44336",
                            cursor: "pointer",
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      style={{
                        padding: 30,
                        textAlign: "center",
                        color: "#777",
                      }}
                    >
                      No banners found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        <div
          style={{
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() => setCurrentPage((p) => p - 1)}
            disabled={currentPage === 1}
            style={{
              padding: "6px 12px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              borderRadius: 4,
              border: "1px solid #ccc",
              background: currentPage === 1 ? "#f5f5f5" : "#fff",
            }}
          >
            Prev
          </button>

          <span style={{ fontSize: "14px" }}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => setCurrentPage((p) => p + 1)}
            disabled={currentPage === totalPages}
            style={{
              padding: "6px 12px",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              borderRadius: 4,
              border: "1px solid #ccc",
              background: currentPage === totalPages ? "#f5f5f5" : "#fff",
            }}
          >
            Next
          </button>
        </div>
      </div>

      {/* ========================= */}
      {/* Modal */}
      {/* ========================= */}

      {modal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            padding: isMobile ? 12 : 20,
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              background: "#fff",
              width: 500,
              maxWidth: "100%",
              maxHeight: "90vh",
              overflowY: "auto",
              padding: isMobile ? 16 : 25,
              borderRadius: 8,
              boxShadow: "0 5px 20px rgba(0,0,0,0.3)",
              boxSizing: "border-box",
            }}
          >
            <h3
              style={{
                marginTop: 0,
                marginBottom: 20,
                fontSize: isMobile ? "18px" : "20px",
              }}
            >
              {editId ? "Edit Home Banner" : "Add Home Banner"}
            </h3>

            <form onSubmit={handleSubmit}>
              {/* Image */}
              <div style={fieldStyle}>
                <label style={labelStyle}>Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={inputStyle}
                />
                {editId && (
                  <small
                    style={{
                      color: "#777",
                      display: "block",
                      marginTop: 5,
                    }}
                  >
                    Leave empty to keep the existing image.
                  </small>
                )}
              </div>

              {/* Title */}
              <div style={fieldStyle}>
                <label style={labelStyle}>Title</label>
                <input
                  type="text"
                  name="title"
                  placeholder="Enter banner title"
                  value={form.title}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              {/* Description */}
              <div style={fieldStyle}>
                <label style={labelStyle}>Description</label>
                <textarea
                  name="description"
                  placeholder="Enter banner description"
                  value={form.description}
                  onChange={handleChange}
                  rows={4}
                  style={{
                    ...inputStyle,
                    resize: "vertical",
                  }}
                />
              </div>

              {/* Button Name */}
              <div style={fieldStyle}>
                <label style={labelStyle}>Button Name</label>
                <input
                  type="text"
                  name="button_name"
                  placeholder="Example: Learn More"
                  value={form.button_name}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              {/* Button URL */}
              <div style={fieldStyle}>
                <label style={labelStyle}>Button URL</label>
                <input
                  type="url"
                  name="button_url"
                  placeholder="https://example.com"
                  value={form.button_url}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column-reverse" : "row",
                  justifyContent: "flex-end",
                  gap: 10,
                  marginTop: 20,
                }}
              >
                <button
                  type="button"
                  onClick={closeModal}
                  style={{
                    background: "#ccc",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: 5,
                    cursor: "pointer",
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  style={{
                    background: "#4CAF50",
                    color: "#fff",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: 5,
                    cursor: "pointer",
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  {editId ? "Update" : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

// =========================
// Styles
// =========================

const thStyle = {
  padding: 12,
  textAlign: "left",
  borderBottom: "1px solid #ddd",
};

const tdStyle = {
  padding: 12,
  borderBottom: "1px solid #ddd",
  verticalAlign: "middle",
};

const fieldStyle = {
  marginBottom: 15,
};

const labelStyle = {
  display: "block",
  marginBottom: 6,
  fontWeight: "bold",
  fontSize: "14px",
};

const inputStyle = {
  width: "100%",
  padding: 10,
  border: "1px solid #ccc",
  borderRadius: 5,
  boxSizing: "border-box",
  fontSize: "14px",
};








function ServeIndia() {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState({ title: '', event_date: '', venue: '', description: '', category: '' });
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchEvents = async () => {
    try {
      const res = await axios.get('https://lcoiapi.emedha.in/appi/serve-india');
      setEvents(res.data);
    } catch (err) {
      console.error("Error fetching data", err);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentEvents = events.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(events.length / itemsPerPage);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`https://lcoiapi.emedha.in/appi/serve-india/${editId}`, form);
        setEditId(null);
      } else {
        await axios.post('https://lcoiapi.emedha.in/appi/serve-india', form);
      }
      setForm({ title: '', event_date: '', venue: '', description: '', category: '' });
      setShowForm(false);
      fetchEvents();
    } catch (err) {
      console.error("Error saving data", err);
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setForm({ title: item.title, event_date: item.event_date, venue: item.venue, description: item.description, category: item.category });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      try {
        await axios.delete(`https://lcoiapi.emedha.in/appi/serve-india/${id}`);
        fetchEvents();
        if (currentEvents.length === 1 && currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      } catch (err) {
        console.error("Error deleting data", err);
      }
    }
  };

  return (
    <div style={{ padding: '24px', maxWidth: '1100px', margin: 'auto', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: '#1e293b', backgroundColor: '#f8fafc', minHeight: '100vh', borderRadius: '12px' }}>
      
      {/* Header Section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px', borderBottom: '1px solid #e2e8f0', paddingBottom: '14px' }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600', color: '#0f172a' }}>We Serve India Management</h2>
          <p style={{ margin: '4px 0 0 0', fontSize: '0.8rem', color: '#64748b' }}>Manage regional events, categories, and descriptions</p>
        </div>
        <button 
          onClick={() => { 
            setShowForm(!showForm); 
            setEditId(null); 
            setForm({ title: '', event_date: '', venue: '', description: '', category: '' }); 
          }}
          style={{ padding: '8px 16px', background: showForm ? '#ef4444' : '#6366f1', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.825rem', fontWeight: '500', cursor: 'pointer', transition: 'background 0.2s' }}
        >
          {showForm ? 'Cancel' : '+ Add New Event'}
        </button>
      </div>

      {/* Collapsible Form Card */}
      {showForm && (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px', background: '#ffffff', padding: '20px', borderRadius: '8px', marginBottom: '24px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.05)' }}>
          <h3 style={{ margin: '0 0 4px 0', fontSize: '1rem', fontWeight: '600', color: '#334155' }}>{editId ? 'Edit Event Details' : 'Create New Event Entry'}</h3>
          
          <input 
            type="text" 
            placeholder="Event Title" 
            value={form.title} 
            onChange={e => setForm({ ...form, title: e.target.value })} 
            required 
            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.85rem', outline: 'none' }} 
          />
          
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <input 
              type="text" 
              placeholder="Date (e.g. 27 October)" 
              value={form.event_date} 
              onChange={e => setForm({ ...form, event_date: e.target.value })} 
              required 
              style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.85rem', minWidth: '200px', outline: 'none' }} 
            />
            <input 
              type="text" 
              placeholder="Venue (e.g. The LaLiT Ashok, Bangalore)" 
              value={form.venue} 
              onChange={e => setForm({ ...form, venue: e.target.value })} 
              required 
              style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.85rem', minWidth: '200px', outline: 'none' }} 
            />
          </div>

          <input 
            type="text" 
            placeholder="Category (e.g. Regional Awards)" 
            value={form.category} 
            onChange={e => setForm({ ...form, category: e.target.value })} 
            required 
            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.85rem', outline: 'none' }} 
          />

          <textarea 
            placeholder="Description..." 
            value={form.description} 
            onChange={e => setForm({ ...form, description: e.target.value })} 
            required 
            style={{ padding: '8px 12px', height: '80px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.85rem', outline: 'none', resize: 'vertical' }} 
          />

          <button 
            type="submit" 
            style={{ padding: '10px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.85rem', fontWeight: '500', cursor: 'pointer' }}
          >
            {editId ? 'Update Record' : 'Save Record'}
          </button>
        </form>
      )}

      {/* Aesthetic Table Section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0, fontSize: '0.95rem', fontWeight: '600', color: '#475569' }}>Existing Entries</h3>
        <span style={{ fontSize: '0.75rem', color: '#64748b' }}>Total: {events.length}</span>
      </div>

      <div style={{ overflowX: 'auto', background: '#ffffff', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.05)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '700px', fontSize: '0.825rem' }}>
          <thead>
            <tr style={{ background: '#f1f5f9', borderBottom: '1px solid #cbd5e1', color: '#475569' }}>
              <th style={{ padding: '10px 14px', fontWeight: '600' }}>Title</th>
              <th style={{ padding: '10px 14px', fontWeight: '600' }}>Category</th>
              <th style={{ padding: '10px 14px', fontWeight: '600' }}>Date & Venue</th>
              <th style={{ padding: '10px 14px', fontWeight: '600' }}>Description</th>
              <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: '600' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentEvents.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ padding: '24px', textAlign: 'center', color: '#94a3b8' }}>No events recorded yet.</td>
              </tr>
            ) : (
              currentEvents.map(item => (
                <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9', transition: 'background 0.1s' }}>
                  <td style={{ padding: '10px 14px', fontWeight: '500', color: '#0f172a' }}>{item.title}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <span style={{ background: '#e0e7ff', color: '#3730a3', padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '500' }}>
                      {item.category}
                    </span>
                  </td>
                  <td style={{ padding: '10px 14px', color: '#334155' }}>
                    {item.event_date}<br/><small style={{ color: '#64748b', fontSize: '0.75rem' }}>{item.venue}</small>
                  </td>
                  <td style={{ padding: '10px 14px', color: '#475569', maxWidth: '280px', lineHeight: '1.3' }}>
                    {item.description.length > 90 ? `${item.description.substring(0, 90)}...` : item.description}
                  </td>
                  <td style={{ padding: '10px 14px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                    <button 
                      onClick={() => handleEdit(item)} 
                      style={{ padding: '4px 10px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '0.75rem', marginRight: '6px', cursor: 'pointer' }}
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(item.id)} 
                      style={{ padding: '4px 10px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '0.75rem', cursor: 'pointer' }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '16px', gap: '6px' }}>
          <button 
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{ padding: '6px 10px', background: currentPage === 1 ? '#e2e8f0' : '#334155', color: currentPage === 1 ? '#94a3b8' : '#fff', border: 'none', borderRadius: '4px', fontSize: '0.75rem', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
          >
            Prev
          </button>
          
          {[...Array(totalPages)].map((_, index) => {
            const pageNum = index + 1;
            return (
              <button
                key={pageNum}
                onClick={() => setCurrentPage(pageNum)}
                style={{
                  padding: '6px 10px',
                  background: currentPage === pageNum ? '#6366f1' : '#ffffff',
                  color: currentPage === pageNum ? '#fff' : '#475569',
                  border: '1px solid #cbd5e1',
                  borderRadius: '4px',
                  fontSize: '0.75rem',
                  cursor: 'pointer',
                  fontWeight: currentPage === pageNum ? '600' : '400'
                }}
              >
                {pageNum}
              </button>
            );
          })}

          <button 
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            style={{ padding: '6px 10px', background: currentPage === totalPages ? '#e2e8f0' : '#334155', color: currentPage === totalPages ? '#94a3b8' : '#fff', border: 'none', borderRadius: '4px', fontSize: '0.75rem', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
export default Admin;
